<template>
  <div class="gold-plan-container">
    <!-- 微信点金计划页面内容 -->
    <div class="header">
      <h1>支付结果</h1>
    </div>

    <div class="content">
      <div class="payment-status">
        <div class="status-icon success">✓</div>
        <h2 class="status-text">支付成功</h2>
      </div>
      <!--
      <div class="loading-tips" v-loading="loading" v-if="orderInfo && orderInfo.Rym">
        <p>正在跳转至票码页面...</p>
        <p class="countdown">（{{ countdown }}秒后自动跳转）</p>
      </div>
      <div class="close-container" v-else>
        <el-button type="default" class="close-btn" @click="handleClose">
          关闭页面
        </el-button>
      </div> -->
      <div class="close-container">
        <el-button type="default" class="close-btn" @click="handleClose">
          关闭页面
        </el-button>
      </div>
    </div>

    <div class="footer" v-if="orderInfo && orderInfo.Ly == 3">
      <el-button type="primary" class="confirm-btn" @click="handleConfirm">
        查看票码
      </el-button>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { useRoute } from "vue-router";
import { dayjs } from "element-plus";
import { shangpindingdan_detailDianJinAny } from "@/http/api";

export default {
  name: "H5WechatGoldPage",
  setup() {
    const route = useRoute();
    const state = reactive({
      loading: false,
      countdown: 5,
      timer: null,
      orderInfo: {},
      orderIndex: 0,
    });

    // 格式化日期
    const formatDate = (dateStr) => {
      return dateStr ? dayjs(dateStr).format("YYYY-MM-DD") : "-";
    };

    // 加载微信点金计划脚本 - 优化版，添加脚本加载性能监控
    const loadGoldPlanScript = () => {
      let head = document.querySelector("head");
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js";
      head.appendChild(script);
      script.onload = () => {
        console.log("微信点金计划脚本加载完成");
      };
      const { out_trade_no, sub_mch_id, check_code } = route.query;
      if (out_trade_no) {
        shangpindingdan_detailDianJinAny(
          out_trade_no,
          sub_mch_id,
          check_code
        ).then((res) => {
          state.orderInfo = res.data;
        });
      }
    };

    const isIOS = () => {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && !u.match(/Android/);
    };

    const handleConfirm = () => {
      try {
        // 对参数进行 URL 编码，避免特殊字符问题
        const encodedPh = encodeURIComponent(state.orderInfo.ph || "");
        const encodedT = encodeURIComponent(state.orderInfo._t || "");
        const targetUrl = `https://www.ahfxwl.com/h5/ticket/${state.orderInfo.Id}?ph=${encodedPh}&_t=${encodedT}`;
        state.orderIndex = state.orderIndex + 1;
        if (isIOS()) {
          console.log("iOS设备，使用直接跳转策略");
          // 同步执行跳转，避免延迟被拦截
          window.location.href = targetUrl;
          // 3秒后检查是否跳转成功，失败则重试
          setTimeout(() => {
            if (window.location.href !== targetUrl) {
              console.warn("跳转失败，尝试备用方案");
              window.location.replace(targetUrl);
            }
          }, 3000);
          return;
        }

        // 非iOS设备逻辑保持不变
        if (window.wx && window.wx.invoke) {
          console.log("非iOS设备，尝试使用微信点金计划跳转");
          window.wx.invoke(
            "jumpOut",
            { jumpType: 1, jumpUrl: targetUrl },
            (res) => {
              console.log("jumpOut调用结果:", res);
              if (res.err_msg !== "jumpOut:ok") {
                console.warn("jumpOut失败，降级跳转");
                window.location.href = targetUrl;
              }
            }
          );
        } else {
          console.log("微信环境异常，直接跳转");
          window.location.href = targetUrl;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        // 错误时强制跳转
        const encodedPh = encodeURIComponent(state.orderInfo.ph || "");
        const encodedT = encodeURIComponent(state.orderInfo._t || "");
        window.location.href = `https://www.ahfxwl.com/h5/ticket/${state.orderInfo.Id}?ph=${encodedPh}&_t=${encodedT}`;
      }
    };

    // 处理关闭页面按钮点击
    const handleClose = () => {
      try {
        // 优先使用微信提供的关闭方法
        if (window.WeixinJSBridge && window.WeixinJSBridge.invoke) {
          window.WeixinJSBridge.invoke("closeWindow", {}, function (res) {
            console.log("微信关闭窗口成功", res);
          });
        } else if (window.wx && window.wx.closeWindow) {
          window.wx.closeWindow();
        } else {
          // 降级处理
          console.log("使用浏览器关闭方法");
          window.close();
        }
      } catch (error) {
        console.error("关闭页面失败:", error);
        // 降级处理
        window.close();
      }
    };

    // 微信商家小票
    const wxInit = () => {
      //初始化小票
      let mchData = {
        action: "onIframeReady",
        displayStyle: "SHOW_CUSTOM_PAGE",
        //   displayStyle: this.out_trade_no
        //     ? 'SHOW_CUSTOM_PAGE'
        //     : 'SHOW_OFFICIAL_PAGE',
      };
      let postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, "https://payapp.weixin.qq.com");
    };

    onMounted(() => {
      // 加载微信点金计划脚本
      loadGoldPlanScript();
      wxInit();
      console.log("wxInit完成");
    });

    // 使用toRefs保持解构属性的响应性
    const { orderInfo, loading, countdown, orderIndex } = toRefs(state);

    return {
      loading,
      countdown,
      orderIndex,
      formatDate,
      orderInfo,
      handleConfirm,
      handleClose,
    };
  },
};
</script>

<style scoped>
.gold-plan-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
  padding: 0 16px;
}

.header {
  padding: 20px 0;
  text-align: center;
}

.header h1 {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.payment-status {
  text-align: center;
  margin-bottom: 30px;
}

.status-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4cd964;
  color: white;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.status-text {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 8px;
}

.order-amount {
  font-size: 16px;
  color: #f56c6c;
  margin: 0 0 4px;
}

.order-number {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.product-info {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 30px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.product-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-right: 16px;
}

.product-details {
  flex: 1;
}

.product-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.use-date {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.loading-tips {
  text-align: center;
  color: #999;
}

.loading-tips p {
  margin: 0;
  font-size: 14px;
}

.countdown {
  margin-top: 4px !important;
  font-size: 12px !important;
}

.close-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.close-btn {
  background-color: #4cd964;
  color: white;
  border: none;
  width: 160px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
}

.close-btn:hover {
  background-color: #34c759;
  color: white;
}

.footer {
  padding: 20px 0;
  width: 100%;
}

.confirm-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 24px;
  background-color: #1677ff;
  border: none;
}

.confirm-btn:hover {
  background-color: #4096ff;
}
</style>
